import request from "@/utils/request";


function touristFlowTrendGetPoiList(data){  //获取景点列表
    return request({
        url: "/touristFlowTrend/getPoiList",
        method: "post",
        data
    })
}

function touristFlowTrendGetCompareList(data){   // 获取对比列表
    return request({
        url: "/touristFlowTrend/getCompareList",
        method: "post",
        data
    })
}

function touristFlowTrendDeleteCompare(data){   // 删除对比分析
    return request({
        url: "/touristFlowTrend/deleteCompare",
        method: "post",
        data
    })
}

function touristFlowTrendAddCompare(data){    // 添加对比分析
    return request({
        url: "/touristFlowTrend/addCompare",
        method: "post",
        data
    })
}

function touristFlowTrendGetTouristTrendByCompareId(data){   //根据对比ID获取趋势列表
    return request({
        url: "/touristFlowTrend/getTouristTrendByCompareId",
        method: "post",
        data
    })
}

function touristFlowTrendGetFlowStructure(data){    // 区县级 市级 省级客流分布
    return request({
        url: "/touristFlowTrend/getFlowStructure",
        method: "post",
        data
    })
}

function touristFlowTrendGetItemSummary(data){   //分项汇总
    return request({
        url: "/touristFlowTrend/getItemSummary",
        method: "post",
        data
    })
}

export {
    touristFlowTrendGetPoiList,
    touristFlowTrendGetCompareList,
    touristFlowTrendDeleteCompare,
    touristFlowTrendAddCompare,
    touristFlowTrendGetTouristTrendByCompareId,
    touristFlowTrendGetFlowStructure,
    touristFlowTrendGetItemSummary
}
